import { Component, OnInit } from '@angular/core';
import { EnvironmentconfigService } from 'src/app/shared/service/environmentconfig.service';
import { WebApiService } from 'src/app/shared/service/webapi.service';
import { AuthService } from 'src/app/shared/auth/auth.service';
import { URLConst } from 'src/app/shared/const/url.const';
import { NzMessageService } from 'ng-zorro-antd/message';
import { DateUtil } from 'src/app/shared/utils/date-format.util';
import { BaseComponent } from 'src/app/shared/base/base.component';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AppConfigService } from 'src/app/shared/service/app-config.service';
import { MatomoTracker } from 'ngx-matomo';
import { LayoutComponent } from 'src/app/layout/layout.component';
interface ItemData {
  id: string;
  site: string;
  companyCode: string;
  supplierId: string;
  supplierName: string;
  account: string;
  bindTime: Date;
  lastLogin: Date;
  expiredReason: string;
  expiredDate: Date;
  vendorMail: string;
  vendorContact: string;
  LoginUserID: string;
}

@Component({
  selector: 'app-wmsm-AdminDowmloadSupplierList',
  templateUrl: './wmsm-AdminDowmloadSupplierList.component.html',
  styleUrls: ['./wmsm-AdminDowmloadSupplierList.component.scss']
})
export class WmsmAdminDowmloadSupplierListComponent extends BaseComponent implements OnInit {
  formValues: any;
  loading: boolean = false;
  validateForm: FormGroup;
  dateFormat = 'yyyy/MM/dd';
  SiteList: any;
  pageSize: number = 20;
  isShowCondition: boolean = true;
  companyCode: "";
  edit: boolean;
  editCache: { [key: string]: { edit: boolean; data: ItemData } } = {};
  datalist: ItemData[] = [];
  // 表格页码
  pageIndex: number = 1;
  nzTotal: number = 0;
  listOfData: any[] = [];
  rolelable: string;
  status: string;
  mobileNumber: string;
  mail: string;

  constructor(
    private Environment: EnvironmentconfigService,
    private webApiService: WebApiService,
    private messageService: NzMessageService,
    private AuthService: AuthService,
    private fb: FormBuilder,
    private matomotracker: MatomoTracker,
    private ConfigService: AppConfigService,
    private LayoutComponent: LayoutComponent,
  ) { super() }

  ngOnInit() {
    this.validateForm = this.fb.group({
      Site: ['', [Validators.required]],
      AccountStatus: [''],
      VendorCode: [],
      VendorAccount: [],
      AccountExpirationDateFrom: [],
      AccountExpirationDateTo: [],

    });
    this.LayoutComponent.geturl()
    this.GetSiteCondition();
    this.matomotracker.trackPageView("系統管理員權限設置")
    this.matomotracker.trackEvent("系統管理員權限設置", "下載供應商賬號清單", "view", 1);
    this.status = '有效'
    const data = [];
    for (let i = 0; i < 100; i++) {
      data.push({
        id: `${i}`,
        vendorMail: `Edrward ${i}`
      });
    }
    this.datalist = data;
    this.updateEditCache();
  }
  exportTableToExecl() {
    this.loading = true;
    const url = `${this.Environment.authConfig.wmsmUrl}${URLConst.DownLoadSupplierAcountListExcel.url}`;
    const params = {
      data: {
        site: this.validateForm.controls['Site'].value,
        status: this.validateForm.controls['AccountStatus'].value == '' ? "All" : this.validateForm.controls['AccountStatus'].value,
        supplierCode: this.validateForm.controls['VendorCode'].value,
        startdate: this.validateForm.controls['AccountExpirationDateFrom'].value,
        enddate: this.validateForm.controls['AccountExpirationDateTo'].value,
        clientId: this.ConfigService.getActualConfig('idmConfig.CLIENT_ID')

      },
    };
    this.webApiService.doPost(url, params, true).subscribe((res) => {
      this.downloadFile8(res, `wmsm_SupplierList${this.getTimeString()}.xlsx`);
      this.loading = false;
    });
  }
  GetSiteCondition(): void {
    this.loading = true;
    const params = '';
    const url = `${this.Environment.authConfig.wmsmUrl}${URLConst.GetVendorSiteCondition.url}`;
    this.webApiService.doGet(url, params).subscribe(
      (res) => {
        if (res) {
          this.SiteList = res;
          this.validateForm.controls['Site'].setValue(res[0]);
        } else {
          this.messageService.error(res.msg);
        }
        this.loading = false;
      },
      (error) => {
        this.messageService.error(error.msg);
        this.loading = false;
      }
    );
  }

  startEdit(sid: string): void {
    this.editCache[sid].edit = true;
  }

  cancelEdit(sid: string): void {
    const index = this.listOfData.findIndex(item => item.sid === sid);
    this.editCache[sid] = {
      data: { ...this.listOfData[index] },
      edit: false
    };
  }

  saveEdit(sid: string): void {
    const index = this.listOfData.findIndex(item => item.sid === sid);
    Object.assign(this.listOfData[index], this.editCache[sid].data);
    this.editCache[sid].edit = false;
    this.loading = true;
    const url = `${this.Environment.authConfig.wmsmUrl}${URLConst.ChangeContactByVendor.url}?LoginUserID=` + (this.AuthService.getCurrentUserInfo()?.userId ?? '');
    const params = {
      data: {
        vendorcode: this.listOfData[sid].supplierId,
        companycode: this.listOfData[sid].companyCode,
        mobileNumber: this.listOfData[sid].account,
        Email: this.editCache[sid].data.vendorMail,
        Person: this.editCache[sid].data.vendorContact,
      },
    };
    this.webApiService.doPost(url, params).subscribe(
      (res) => {
        if (res.status == "200") {
          this.messageService.success(res.msg);
          this.loading = false;
        } else {
          this.messageService.error(res.msg);
          this.loading = false;
        }
        this.editCache[sid].edit = false;
        this.getResultData();
      },
      (error) => {
        this.messageService.error(error.msg);
        this.loading = false;
      }
    );

  }

  updateEditCache(): void {
    this.listOfData.forEach(item => {
      this.editCache[item.sid] = {
        edit: false,
        data: { ...item }
      };
    });
  }

  getResultData() {
    this.loading = true;
    const url = `${this.Environment.authConfig.wmsmUrl}${URLConst.GetVendorContact.url}?LoginUserID=` + (this.AuthService.getCurrentUserInfo()?.userId ?? '');
    const params = {
      pageSize: this.pageSize,
      pageIndex: this.pageIndex,
      data: {
        site: this.validateForm.controls['Site'].value,
        status: this.validateForm.controls['AccountStatus'].value == '' ? "All" : this.validateForm.controls['AccountStatus'].value,
        supplierCode: this.validateForm.controls['VendorCode'].value,
        supplierAccount: this.validateForm.controls['VendorAccount'].value,
        startdate: this.validateForm.controls['AccountExpirationDateFrom'].value,
        enddate: this.validateForm.controls['AccountExpirationDateTo'].value,
        clientId: this.ConfigService.getActualConfig('idmConfig.CLIENT_ID'),

      },
    };
    this.webApiService.doPost(url, params).subscribe(
      (res) => {
        if (res && res.status == this.Environment.authConfig.wmsmStatus) {
          this.listOfData = res.data.map((item) => {
            item.bindTime = DateUtil.formatYMD(item.bindTime);
            item.lastLogin = DateUtil.formatYMD(item.lastLogin);
            item.expiredDate = DateUtil.formatYMD(item.expiredDate);
            return item;
          });
          this.nzTotal = res.total;
          this.messageService.success(res.msg);
        } else {
          this.listOfData = [];
          this.nzTotal = 0;
          this.messageService.warning(res.msg);
        }
        this.updateEditCache()
        this.loading = false;
      },
      (error) => {
        this.messageService.error(error.msg);
      }
    );
  }

  // 切换页码
  nzPageIndexChange(event: number): void {
    this.pageIndex = event;
    this.getResultData();
  }

  // 切换每页数据条数
  nzPageSizeChange(event: number): void {
    if (this.nzTotal === 0) {
      return;
    }
    this.pageSize = event;
    if (event * this.pageIndex > this.nzTotal && this.pageIndex > 1) {
      this.pageIndex--;
    }
    this.getResultData();
  }

  getFormValue(value) {
    this.formValues = value;
  }

  onSearch() {
    //this.isShowCondition = !this.isShowCondition;
    this.pageIndex = 1;
    this.getResultData();
  }

  Condition() {
    if (this.isShowCondition == false) {
      this.isShowCondition = true;
    } else {
      this.isShowCondition = false;
    }
  }


  getValue(idmflag, companyCode, account) {
    this.loading = true;
    const params = {
      data: {
        IDMFlag: idmflag,
        CompanyCode: companyCode,
        MobileNumber: account
      }
    }
    const url = `${this.Environment.authConfig.wmsmUrl}${URLConst.DeleteVendor.url}`;
    this.webApiService.doPost(url, params).subscribe(
      (res) => {
        if (res && res.status == this.Environment.authConfig.wmsmStatus) {
          this.getResultData();
        }
        this.loading = false;
      },
      (error) => {
        this.messageService.error(error.msg);
      }
    );
  }

  getidmflag(idmflag) {
    if (idmflag == 'Y') {
      this.status = '有效';
    }
    else {
      this.status = '失效';
    }
  }
}
